import React, { Component } from "react";

class CheckBoxSquareSVG extends React.Component {
  render() {
    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 12 12"
      >
        <rect className="svg" x="2.5" y="2.5" width="7" height="7" />
      </svg>
    );
  }
}

export default CheckBoxSquareSVG;



// WEBPACK FOOTER //
// ./src/svg/CheckBoxSquareSVG.jsx